import { createApi } from '@reduxjs/toolkit/query/react';
import { CheckAvailableTemplates } from '../../api/endpoints';
import { MODULE_TYPES } from '../../config/moduleTypes';
import {baseQueryWithReauth} from "../../api/baseQuery";

// Used to be 5 near-identical endpoints (getMentalTemplates, getFysiskTemplates, ...) plus a
// commented-out 6th (getProSimTemplates) that was scaffolded once and abandoned. Collapsed into
// one parameterized endpoint driven by the module-type registry — a 6th type needs zero new
// endpoint wiring here, just a new entry in ../../config/moduleTypes.js.
export const getTemplateApi = createApi({
  reducerPath: 'getTemplateApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Templates'],
  endpoints: (builder) => ({
    getTemplatesByType: builder.query({
      query: (typeKey) => ({ url: MODULE_TYPES[typeKey]?.endpoints.getAll, method: 'GET' }),
      providesTags: ['Templates'],
    }),
    deleteTemplate: builder.mutation({
      query: ({ deleteUrl, templateId }) => ({
        url: deleteUrl,
        method: 'POST',
        body: {
          templateId
        }
      }),
      invalidatesTags: ['Templates'],
    }),
    checkAvailableTemplates: builder.query({
      query: () => ({ url: CheckAvailableTemplates, method: 'GET'})
    }),
      addTemplate: builder.mutation({
      query: ({ templateUrl, params }) => ({
        url: templateUrl,
        method: 'POST',
        body: params
      }),
      invalidatesTags: ['Templates'],
  }),
  }),
});

export const { useGetTemplatesByTypeQuery, useDeleteTemplateMutation, useCheckAvailableTemplatesQuery, useAddTemplateMutation} = getTemplateApi;
